import { Filter, ConditionOperatorsEnum } from 'utils/filters';

export const filterOptions: Filter[] = [
  {
    field: 'partner_name',
    label: 'DYNAMIC_FILTER.PARTNER_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'company_name',
    label: 'DYNAMIC_FILTER.COMPANY_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'partner_alias',
    label: 'DYNAMIC_FILTER.PARTNER_ALIAS_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'allow_sso_configuration',
    label: 'DYNAMIC_FILTER.ALLOW_SSO_CONFIG_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'has_custom_frontend',
    label: 'DYNAMIC_FILTER.CUSTOM_FRONTEND_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'partner_new_front_enabled',
    label: 'DYNAMIC_FILTER.PARTNER_NEW_FRONT_ENABLED_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  { field: 'ldap_server', label: 'DYNAMIC_FILTER.LDAP_SERVER_KEY' },
  {
    field: 'ldap_type',
    label: 'DYNAMIC_FILTER.LDAP_TYPE_KEY',
    multiple: true,
    isSelect: true,
    selectOptions: [
      { value: 'internal', label: 'DYNAMIC_FILTER.INTERNAL_KEY' },
      { value: 'external', label: 'DYNAMIC_FILTER.EXTERNAL_KEY' },
      { value: 'managed', label: 'DYNAMIC_FILTER.MANAGED_KEY' },
    ],
  },
  {
    field: 'oci_compartment_id',
    label: 'DYNAMIC_FILTER.OCI_COMPARTMENT_ID_KEY',
  },

  { field: 'role_aws', label: 'DYNAMIC_FILTER.ROLE_AWS_KEY' },
  {
    field: 'provider_type',
    label: 'DYNAMIC_FILTER.PROVIDER_TYPE_KEY',
    multiple: true,
    isSelect: true,
    selectOptions: [
      { value: 'aws', label: 'DYNAMIC_FILTER.AWS_KEY' },
      { value: 'oci', label: 'DYNAMIC_FILTER.OCI_KEY' },
      { value: 'multicloud', label: 'DYNAMIC_FILTER.MULTICLOUD_KEY' },
    ],
  },
  {
    field: 'allow_sso_configuration',
    label: 'PARTNER_PAGE.SSO_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  { field: 'partner_uuid', label: 'DYNAMIC_FILTER.PARTNER_UUID_KEY' },
  { field: 'company_uuid', label: 'DYNAMIC_FILTER.COMPANY_UUID_KEY' },
];
